import { useQuery } from '@tanstack/react-query';
import { connect, useSelector } from 'react-redux';
import FilterDateComponent from '../../../components/common/FilterDateComponent';
import BreadCrumb from '../../../components/template/BreadCrumb';
import Header from '../../../components/template/Header';
import api from '../../../domain/api';
import EmployeeSidebar from './Employee-Sidebar';
import DashboardGalleryPage from './gallery/gallery-page';
import PendingTasksTable from './Pending-Tasks-Table';
import DashboardStatsGrid from './Stat-Grid';

import { useLocation } from 'react-router-dom';

import * as qs from 'qs';
import { useMemo } from 'react';

import hrPolicies from '../../../assets/Policies.pdf';

const EnhancedDashboard = () => {
  const user = useSelector((state) => state.auth.user);

  const location = useLocation();

  const queryParams = useMemo(() => {
    return qs.parse(location.search.replace('?', ''));
  }, [location.search]);

  const { data: dashboards } = useQuery({
    queryKey: ['dashboardData', queryParams],

    queryFn: async () => {
      const queryParams = qs.parse(window.location.search.replace('?', ''));

      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      console.log('Query Parameters for Dashboards:', query);

      const { data } = await api.get(`/dashboards?${query}`);
      return data;
    },
  });

  // const [data] = useAllDashboards();
  // const { dashboards } = data;

  const {
    data: employeeData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['employees'],
    queryFn: async () =>
      api.get('/employees?limit=1000').then((res) => res.data),
  });

  const Today = (person) => {
    const currentDay = new Date().getDate();
    const currentMonth = new Date().getMonth();

    const filter =
      person &&
      person.filter((data) => {
        const day = new Date(data.dob).getDate();
        const month = new Date(data.dob).getMonth();
        return currentDay == day && currentMonth == month;
      });
    return filter;
  };

  const TodayDOJ = (person) => {
    const currentDay = new Date().getDate();
    const currentMonth = new Date().getMonth();

    const filter =
      person &&
      person.filter((data) => {
        const day = data.doj && new Date(data.doj).getDate();
        const month = data.doj && new Date(data.doj).getMonth();
        return currentDay == day && currentMonth == month;
      });
    return filter;
  };

  const Upcoming = (employees, toMonth = 3) => {
    const today = new Date();
    const currentYear = today.getFullYear();

    const upcoming = employees
      ?.filter((emp) => emp.dob)
      ?.map((emp) => {
        const dob = new Date(emp.dob);
        let nextBirthday = new Date(currentYear, dob.getMonth(), dob.getDate());

        // If the birthday already occurred this year, set it to next year
        if (nextBirthday < today) {
          nextBirthday = new Date(
            currentYear + 1,
            dob.getMonth(),
            dob.getDate()
          );
        }

        return {
          ...emp,
          nextBirthday,
          timeToBirthday: nextBirthday - today,
        };
      })
      ?.filter((emp) => {
        const monthsDiff =
          (emp.nextBirthday.getFullYear() - today.getFullYear()) * 12 +
          (emp.nextBirthday.getMonth() - today.getMonth());
        return monthsDiff <= toMonth;
      })
      .sort((a, b) => a.timeToBirthday - b.timeToBirthday)
      .slice(0, 5);

    return upcoming;
  };

  const UpcomingDOJ = (person, toMonth = 3) => {
    const today = new Date();
    const currentYear = today.getFullYear();

    const filtered = person
      ?.filter((data) => data.doj)
      ?.map((data) => {
        const dojDate = new Date(data.doj);
        let nextDOJ = new Date(
          currentYear,
          dojDate.getMonth(),
          dojDate.getDate()
        );

        // If this year's DOJ has passed, shift to next year
        if (
          nextDOJ < today ||
          (nextDOJ.getDate() === today.getDate() &&
            nextDOJ.getMonth() === today.getMonth())
        ) {
          nextDOJ = new Date(
            currentYear + 1,
            dojDate.getMonth(),
            dojDate.getDate()
          );
        }

        return {
          ...data,
          nextDOJ,
          timeToDOJ: nextDOJ - today,
        };
      })
      ?.filter((data) => {
        const monthsDiff =
          (data.nextDOJ.getFullYear() - today.getFullYear()) * 12 +
          (data.nextDOJ.getMonth() - today.getMonth());
        return monthsDiff >= 0 && monthsDiff <= toMonth;
      })
      .sort((a, b) => a.timeToDOJ - b.timeToDOJ);

    return filtered;
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />

        <div
          style={{
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            padding: '15px 20px',
            marginBottom: '20px',
            borderRadius: '10px',
            border: '1px solid #e3e9f3',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05)';
          }}
        >
          <a
            href={hrPolicies}
            target='_blank'
            style={{
              color: '#1a73e8',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <span
              style={{
                backgroundColor: '#e8f0fe',
                padding: '8px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              📄
            </span>
            <span>HR Policies Document - Click to View</span>
            <span
              style={{
                backgroundColor: '#e8f0fe',
                padding: '4px 12px',
                borderRadius: '15px',
                fontSize: '12px',
                color: '#1967d2',
                marginLeft: '10px',
              }}
            >
              View PDF
            </span>
          </a>
        </div>

        <BreadCrumb
          title='Dashboard'
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink='Main'
        />

        <FilterDateComponent link='/dashboard' />

        <div className='container-fluid enhanced-dashboard'>
          <div className='row'>
            {/* Main Content Area */}
            <div className='col-lg-8'>
              {/* Stats Grid */}
              {user &&
                (user.role == 'SUPER ADMIN' || user.role == 'MANAGER') && (
                  <DashboardStatsGrid dashboards={dashboards} />
                )}

              {/* Pending Tasks */}
              <PendingTasksTable dashboards={dashboards} />

              {/* Important Dates Card */}
              <div className='card enhanced-card'>
                <div className='card-header enhanced-card-header'>
                  <div className='d-flex align-items-center'>
                    <i className='fas fa-calendar-alt me-2 text-primary'></i>
                    <strong>Important Dates</strong>
                  </div>
                </div>
                <div className='card-body'>
                  <div className='important-dates-content'>
                    <div className='schedule-item'>
                      <h6 className='schedule-title'>
                        <i className='fas fa-users me-2 text-info'></i>
                        Monthly Schedule for Client's Meeting:
                      </h6>
                    </div>
                    <div className='schedule-list'>
                      <div className='schedule-item'>
                        <span className='schedule-date'>22nd:</span>
                        <span className='schedule-desc'>
                          Report and Meeting
                        </span>
                      </div>
                      <div className='schedule-item'>
                        <span className='schedule-date'>24th:</span>
                        <span className='schedule-desc'>
                          Content Deck with Content will be shared with the
                          client as per the strategy for approval.
                        </span>
                      </div>
                      <div className='schedule-item'>
                        <span className='schedule-date'>26th:</span>
                        <span className='schedule-desc'>
                          Content Deck with Creatives/Videos will be shared with
                          the client for approval.
                        </span>
                      </div>
                      <div className='schedule-item'>
                        <span className='schedule-date'>28th:</span>
                        <span className='schedule-desc'>
                          Scheduling on SM platforms
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className='col-lg-4'>
              <EmployeeSidebar
                dashboards={dashboards}
                employees={employeeData?.employees}
                Today={Today}
                TodayDOJ={TodayDOJ}
                Upcoming={Upcoming}
                UpcomingDOJ={UpcomingDOJ}
              />
            </div>
          </div>

          <DashboardGalleryPage />
        </div>

        <style jsx>{`
          .enhanced-dashboard {
            padding: 25px 15px;
          }

          .enhanced-marquee-container {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border-bottom: 1px solid #dee2e6;
            padding: 12px 0;
            margin-bottom: 20px;
          }

          .marquee-item {
            padding: 2px 0;
          }

          .marquee-enhanced {
            font-size: 12px;
            font-weight: 500;
            line-height: 1.4;
          }

          .marquee-text-primary {
            color: #e41d2e;
            padding-left: 400px;
          }
          .marquee-text-default {
            color: #495057;
          }
          .marquee-text-success {
            color: #afb42b;
            padding-left: 400px;
          }
          .marquee-text-warning {
            color: #fa7070;
            padding-left: 400px;
          }
          .marquee-text-info {
            color: deeppink;
            padding-left: 400px;
          }
          .marquee-text-accent {
            color: #367e18;
            padding-left: 400px;
          }

          .enhanced-card {
            border: 1px solid #e3e9f3;
            border-radius: 12px;
            box-shadow: rgb(227 233 243) 0px 4px 22px;
            margin-bottom: 25px;
            background: #fff;
          }

          .enhanced-card-header {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border-bottom: 1px solid #e3e9f3;
            padding: 16px 20px;
            font-size: 14px;
            font-weight: 600;
            color: #495057;
            border-radius: 12px 12px 0 0;
          }

          .important-dates-content {
            padding: 20px;
          }

          .schedule-title {
            color: #495057;
            font-size: 13px;
            font-weight: 600;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
          }

          .schedule-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .schedule-item {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 10px 0;
            border-bottom: 1px solid #f1f3f4;
          }

          .schedule-item:last-child {
            border-bottom: none;
            padding-bottom: 0;
          }

          .schedule-date {
            font-weight: 600;
            color: #495057;
            font-size: 12px;
            min-width: 45px;
            background: #e9ecef;
            padding: 4px 8px;
            border-radius: 6px;
            text-align: center;
            flex-shrink: 0;
          }

          .schedule-desc {
            font-size: 12px;
            color: #6c757d;
            line-height: 1.5;
            flex: 1;
          }

          @media (max-width: 768px) {
            .enhanced-dashboard {
              padding: 15px 10px;
            }

            .enhanced-card {
              margin-bottom: 20px;
            }

            .enhanced-card-header {
              padding: 12px 16px;
            }

            .important-dates-content {
              padding: 16px;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ auth: state.auth });
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EnhancedDashboard);
